import classNames from 'classnames'
import cn from 'classnames'
import { LinkProps } from 'next/link'
import React from 'react'
import { ModalContent } from './ModalManager'
import { TabProps } from './Tab'
import { Tabs, TabsView } from './Tabs'

export interface TabsPanelProps {
	items: Array<{
		label: TabProps['label']
		content: React.ReactNode
		wide?: boolean,
		align?: 'center' | 'left',
		linkProps?: LinkProps
	}>
	isModalHeader?: boolean
	initialIndex?: number
}

export const TabsPanel: React.FunctionComponent<TabsPanelProps> = ({
	items,
	isModalHeader,
	initialIndex = 0,
}) => {
	const [selected, setSelected] = React.useState(initialIndex)

	return (
		<div className={cn('tabsPanel', isModalHeader && 'view-modalHeader')}>
			<div className="tabsPanel-header">
				<Tabs
					items={items}
					onChange={setSelected}
					view={isModalHeader ? TabsView.popup : TabsView.contained}
					initialIndex={initialIndex}
				/>
			</div>
			<ModalContent>
				<div className="tabsPanel-content">
					<div className="tabsPanel-content-in">
						{items.map((item, i) => (
							<React.Fragment key={i}>
								{selected === i && (
									
									<div className={classNames(
										'tabsPanel-item', 
										item.wide ? 'tabsPanel-item-wide' : '',
										item.align === 'left' ? 'tabsPanel-item-left' : ''
									)}>{item.content}</div>
								)}
							</React.Fragment>
						))}
					</div>
				</div>
			</ModalContent>
		</div>
	)
}
